<dxc-application-layout-sidenav
  padding="medium"
  class="collapse-sidenav"
  mode="push"
>
  <div class="sidenavContent text-left h-100">
    <ng-container *ngIf="isShowProfile(); else navHeadTitle">
      <div class="sidenav-profile">
        <img
          src="{{
            RESOURCE_SERVER_URL +
              '/assets/images/Underwriting_new/Side Menu/Profile_pic 2.svg'
          }}" alt="Profile Image"
        />
        <div class="py-4">
          <div class="user-name">
            <p>Mr. John Doe</p>
          </div>
          <div class="user-id">
            <label>Profile ID - 001112</label>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #navHeadTitle>
      <h1 class="sidenav-title">{{ "label.common.navigation" | translate }}</h1>
    </ng-template>
    <div theme>
      <div class="col-12 row navigation mx-0 px-0" *ngIf="'button' == menuType">
        <div class="col-12 px-0" *ngFor="let item of listMenu">
          <div
            class="sidenav-card"
            (click)="onClick(item)"
            [class.active]="item.isSelected"
          >
            <div class="row sidenav-card-content">
              <div class="col-xl-12 d-flex">
                <img src="{{ item.icon }}" alt="Item Icon" class="iconsColors"/>
                <p class="menu-title">{{ item.name | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</dxc-application-layout-sidenav>
